import { ThreeDModelState } from "./shared";
import React, { useEffect } from "react";
import { StoreWithDispatchAction } from "../../store/hooks/use-store";

export function useModelStateEffects(
  modelState: ThreeDModelState,
  previousModelState: ThreeDModelState | null,
  isTouchDevice: boolean,
  divRef: React.RefObject<HTMLDivElement | null>,
  dispatch: React.Dispatch<StoreWithDispatchAction>,
) {
  useEffect(() => {
    const { current } = divRef;

    if (isTouchDevice && current) {
      if (
        modelState === "interacted-with" ||
        (previousModelState && previousModelState === "interacted-with" && modelState === "idle")
      ) {
        current.scrollIntoView({ behavior: "smooth", block: "start" });

        dispatch({
          type: "set-header-floating-disabled",
          value: true,
        });

        return () => {
          dispatch({
            type: "set-header-floating-disabled",
            value: false,
          });
        };
      }
    }
  }, [modelState]);
}
